import { FadeUp, MaskLines } from "./Reveal";

const STEPS = [
  { n: "01", t: "Discover", d: "A 30-minute call to map your workflow." },
  { n: "02", t: "Configure or build", d: "Start from our SaaS or custom-build on top." },
  { n: "03", t: "Launch", d: "Migration, integrations and team training." },
  { n: "04", t: "Grow", d: "Ongoing support and AI upgrades." },
];

export default function HowWeWork() {
  return (
    <section className="scroll-mt-20 bg-paper py-24 text-[#0f0f14] md:py-28">
      <div className="mx-auto max-w-[1160px] px-6">
        <FadeUp>
          <p
            className="text-[13px] font-semibold uppercase tracking-[0.18em] text-brand"
            data-testid="how-we-work-eyebrow"
          >
            05 — How We Work
          </p>
        </FadeUp>

        <MaskLines
          lines={["Four steps. No surprises."]}
          className="mt-8 text-[clamp(2.5rem,5.4vw,4.6rem)] font-normal leading-[1.04] tracking-[-0.025em]"
        />

        <div className="mt-20 grid gap-x-10 gap-y-14 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <FadeUp key={s.n} delay={i * 0.08} className="border-t border-black/[0.12] pt-9">
              <p
                className="text-[clamp(3rem,4.2vw,4rem)] font-normal leading-none tracking-[-0.02em] text-brand"
                data-testid={`work-step-${s.n}`}
              >
                {s.n}
              </p>
              <h3 className="mt-8 text-[26px] font-medium tracking-[-0.01em]">{s.t}</h3>
              <p className="mt-3 max-w-[260px] text-[16px] leading-[1.6] text-[#54545c]">{s.d}</p>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
